import { useEffect } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
const primaryColor = "#C54D61";
const secondaryColor = "#003A56";
const backgroundColor = "#003e51";
const liveChatWidgetProps = {
  chatButtonProps: {
    controlProps: {
      hideChatSubtitle: true
    },
    styleProps: {
      titleStyleProps: {
        color: secondaryColor
      }
    }
  },
  headerProps: {
    controlProps: {
      hideIcon: true
    },
    styleProps: {
      generalStyleProps: {},
      titleStyleProps: {
        marginLeft: "5px"
      }
    }
  },
  webChatContainerProps: {
    webChatStyles: {
      bubbleBackground: backgroundColor,
      bubbleBorderRadius: 8,
      bubbleBorderWidth: 1,
      bubbleTextColor: "white",
      bubbleFromUserBackground: "white",
      bubbleFromUserTextColor: "black",
      bubbleFromUserBorderRadius: 8,
      bubbleFromUserBorderWidth: 1,
      suggestedActionBorderRadius: 8,
      suggestedActionHeight: 32,
      suggestedActionLayout: "flow",
      suggestedActionBackgroundColor: "white",
      suggestedActionBorderColor: "#7F9CAA",
      suggestedActionTextColor: secondaryColor
    },
    renderingMiddlewareProps: {
      avatarStyleProps: {
        backgroundImage: "url('https://cdn.myclarionhousing.com/-/jssmedia/clarion-housing-association/images/components-page/ha-logo.png?w=600&h=auto&mw=600&rev=ed27887248474e2692ebcfc0d4dc94b0')",
        backgroundColor: "transparent",
        backgroundSize: "cover"
      },
      avatarTextStyleProps: {
        display: "none"
      }
    },
    adaptiveCardStyles: {
      background: backgroundColor,
      color: "#FFFFFF"
    }
  },
  footerProps: {
    styleProps: {
      downloadTranscriptButtonStyleProps: {
        icon: {
          color: "black",
          fontSize: "20px"
        }
      },
      emailTranscriptButtonStyleProps: {
        icon: {
          color: "black",
          fontSize: "20px"
        }
      },
      audioNotificationButtonStyleProps: {
        icon: {
          color: "black",
          fontSize: "20px"
        }
      }
    }
  },
  scrollBarProps: {
    trackBackgroundColor: secondaryColor
  },
  loadingPaneProps: {
    controlProps: {
      titleText: "Connecting you to",
      hideSubtitle: false,
      subtitleText: "Clarion chat support"
    }
  }
};
const CopilotChatbot = ({
  sitecoreContext,
  t,
  ...props
}) => {
  const appId = sitecoreContext?.chatbotSetting?.copilotChatWidgetAppId || "";
  const cookie = useSelector(state => state.cookie);
  const orgId = sitecoreContext?.chatbotSetting?.copilotChatWidgetOrgId || "";
  const orgUrl = sitecoreContext?.chatbotSetting?.copilotChatWidgetOrgUrl || "";
  const loadChat = () => {
    window.lcw = () => liveChatWidgetProps;
    const script = document.createElement("script");
    script.setAttribute("v2", "");
    script.id = "Microsoft_Omnichannel_LCWidget";
    script.src = "https://oc-cdn-public-gbr.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";
    script.setAttribute("data-app-id", appId);
    script.setAttribute("data-lcw-version", "prod");
    script.setAttribute("data-org-id", orgId);
    script.setAttribute("data-org-url", orgUrl);
    script.setAttribute("data-color-override", primaryColor);
    script.setAttribute("data-font-family-override", "Din OT, sans-serif");
    script.setAttribute("data-customization-callback", "lcw");
    script.setAttribute("data-suggested-action-layout", "stacked");
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  };
  useEffect(() => {
    if (cookie.isThirdPartyEnabled) {
      // Only load chat if 3rd party cookies toggled on since 3rd party code can set unwanted cookies
      loadChat();
    }
  }, [cookie.isThirdPartyEnabled]);
};
const CopilotChatbotWithTranslation = withTranslation()(CopilotChatbot);
export default withSitecoreContext()(CopilotChatbotWithTranslation);